// extracted by mini-css-extract-plugin
export default {"reward-equips-bug-wrapper":"RewardEquipsBuy_reward-equips-bug-wrapper_KO2Uw","reward-equips-bug":"RewardEquipsBuy_reward-equips-bug_Yyg6c"};